<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { format } from 'svelte-i18n';

	import type { UpdateModeSubTypes, UpdateModeTypes } from 'src/stores/ui/edit_lists';

	//Design system components
	import { Modal, CardGrid, SelectCard, Icon, LinkWithIcon } from '@Shelly/shelly-design-system';
	import { mapIconSolidWeightToLight } from 'src/helpers/new-layout-helpers';
	import { firstCharCapOnly } from 'src/helpers/utilities';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	const dispatch = createEventDispatcher<{
		close: void;
		'menu-item-click': { callback: () => void };
		'ai-command-click': { type: UpdateModeTypes; subType: UpdateModeSubTypes };
	}>();

	export let showModalMenu: boolean = false;
	export let dropdownMenuMenuData: Array<{
		title: string;
		icon: string;
		callback: () => void;
	}> = [];
	export let isEmptyDeviceList: boolean = false;
	export let AIModelCommands: Array<{
		name: string;
		id: UpdateModeSubTypes;
		icon: string;
	}> = [];

	let showAiModelOptions = false;

	const closeModalMenu = () => {
		showModalMenu = false;
		showAiModelOptions = false;
		dispatch('close');
	};

	const handleMenuItemClick = (menuItemList: { title: string; callback: () => void }) => {
		const isAiModel = menuItemList.title === $format('ai_model');

		if (!isAiModel) {
			dispatch('menu-item-click', { callback: menuItemList.callback });
			closeModalMenu();
		} else {
			showAiModelOptions = true;
		}
	};

	const handleAiCommandClick = (modelCommand: { id: UpdateModeSubTypes }) => {
		dispatch('ai-command-click', { type: 'ai_device_failure', subType: modelCommand.id });
		showAiModelOptions = false;
		closeModalMenu();
	};
</script>

<Modal bind:showModal={showModalMenu} on:close={closeModalMenu} hideTitle>
	<svelte:fragment slot="content">
		{#if showAiModelOptions}
			<LinkWithIcon
				class="mb-m"
				textClasses="size-m-button-min-height"
				icon="fa-light fa-chevron-left"
				text={$format('text_button_back', {
					default: 'Back',
				})}
				on:click={() => {
					showAiModelOptions = false;
				}}
			/>
			<CardGrid md={250} noPaddingBottom gridGap="s">
				{#each AIModelCommands as modelCommand}
					<SelectCard
						cardBgColor={$showNewLayout ? 'color-1' : undefined}
						hideAction
						class="width-full"
						type="horizontal"
						title={$format(modelCommand.name)}
						icon={mapIconSolidWeightToLight(modelCommand.icon)}
						on:click={() => handleAiCommandClick(modelCommand)}
					/>
				{/each}
			</CardGrid>
		{:else}
			<CardGrid md={250} noPaddingBottom gridGap="s">
				{#each dropdownMenuMenuData as menuItemList}
					{@const isAiModel = menuItemList.title === $format('ai_model')}
					<SelectCard
						cardBgColor={$showNewLayout ? 'color-1' : undefined}
						hideAction
						class="width-full"
						type="horizontal"
						title={isAiModel ? menuItemList.title : firstCharCapOnly(menuItemList.title)}
						icon={mapIconSolidWeightToLight(menuItemList.icon)}
						on:click={() => handleMenuItemClick(menuItemList)}
						disabled={isEmptyDeviceList}
						hideRightCustomAction={!isAiModel}
					>
						<Icon size="s" slot="customActionRight" icon="fa-regular fa-chevron-right" />
					</SelectCard>
				{/each}
			</CardGrid>
		{/if}
	</svelte:fragment>
</Modal>
